var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['fac-wrapper', _vm.direction]},[_vm._m(0),_vm._v(" "+_vm._s(_vm.data)+" ")])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon"},[_c('i',{staticClass:"far fa-check"})])
}]

export { render, staticRenderFns }